import { Outlet, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Cookies from 'js-cookie';

import decodeJWT from 'utils/token';
import { otherTabsState } from 'recoil/atom/otherTabs.atom';
import LINK from 'constants/link';
import TOKEN from 'constants/auth';

import Footer from './Footer';
import Header from './Header';
import MobileHeader from './Mobile/Header';
import Seo from '../Seo/Seo';

function Layout() {
	const decodedPayload = decodeJWT(TOKEN.ACCESS);
	const { companyName } = decodedPayload;

	const navigate = useNavigate();
	const [otherTab, setOtherTab] = useRecoilState(otherTabsState);

	const handleLogout = () => {
		Cookies.remove(TOKEN.ACCESS);
		Cookies.remove(TOKEN.REFRESH);
		setOtherTab({});
		navigate(LINK.LOGIN);
	};

	return (
		<>
			<Seo />
			<Header logout={handleLogout} name={companyName} />
			<MobileHeader logout={handleLogout} name={companyName} />
			<Outlet />
			<Footer />
		</>
	);
}

export default Layout;
